import {get} from 'lodash';
import {PAYMENT_STAUS, RESERVATION_STATUS} from '../components/constants';

export function getItem1(listingData) {
    const {isCrossSell = false, isBasicListing = false} = listingData || {};
    let result = '1';
    if (isCrossSell) result = '2';
    if (isBasicListing) result = '3';
    return result;
}

export function getItem2(listingData) {
    const {
        instantBookable = false,
        payPerBooking = false,
        onlineBookable = false,
        acceptsHomeAwayPayments = false,
    } = listingData || {};
    let result = '4';
    if (instantBookable) result = '1';
    if (onlineBookable) result = '2';
    if (payPerBooking && onlineBookable) result = '5';
    if (acceptsHomeAwayPayments) result = '3';
    return result;
}

export function getItem3(listingData) {
    const {isSubscription = false, payPerBooking = false} = listingData || {};
    let result = '4';
    if (isSubscription) result = '1';
    if (payPerBooking) result = '2';
    return result;
}

export function getItem4(listingData) {
    const [IPM, PPM, FRBO] = ['1', '2', '3'];
    const {
        integratedPropertyManager: isIPM = false,
        platformPropertyManager: isPPM = false,
    } = listingData || {};
    let result = FRBO;
    if (isIPM || isPPM) result = isIPM ? IPM : PPM;
    return result;
}

export const getPaymentSplit = (ecomPriceDetails, reservationStatus) => {
    const payments = get(ecomPriceDetails, 'payments', []);
    const completedPayments =
        reservationStatus === RESERVATION_STATUS.UNCONFIRMED_BY_OWNER
            ? 1
            : payments?.filter((item) => item?.status === PAYMENT_STAUS.PAID)
                  ?.length;
    return payments?.length ? `${completedPayments}/${payments.length}` : null;
};
